import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'

export const PASS_REQUEST_TYPE = {
  alias: RequestTypeAlias.Pass,
  iconLink: 'https://storage.yandexcloud.net/s3smx-tst/MPS_icons/pass.svg',
  name: 'Заказать пропуск',
  description:
    'Оформить постоянный пропуск для себя или члена семьи. Заказать разовый пропуск для гостя или курьера'
}

export const CREATE_REQUEST_TYPE = {
  alias: RequestTypeAlias.CommonRequest,
  name: 'Оставить обращение'
}

export const DEFAULT_REQUIRED_FIELD = 1

export const DEFAULT_TIMEZONE = 'Europe/Moscow'

export const DEFAULT_DATE_ONLY_FORMAT = 'YYYY-MM-DD'

export const DEFAULT_FULL_NAME_LENGTH = 55
export const DEFAULT_FULL_NAME_LENGTH_MESSAGE_FROM = 50

export const DEFAULT_AUTO_NUMBER_MAX_LENGTH = 20
export const DEFAULT_AUTO_NUMBER_MAX_LENGTH_MESSAGE_FROM = 15
export const DEFAULT_AUTO_MODEL_MAX_LENGTH = 50
export const DEFAULT_AUTO_MODEL_MAX_LENGTH_MESSAGE_FROM = 40

export const FILES_TOTAL_SIZE_EXCEEDED_MESSAGE =
  'Общий объем файлов не может превышать 200Мб'

export const CONST_STICKY_FOOTER_HEIGHT = 56 + 24

export const permanentTypeAliases = new Set([
  RequestTypeAlias.PermanentPassAuto,
  RequestTypeAlias.PermanentPassFamily,
  RequestTypeAlias.PermanentPassRenter,
  RequestTypeAlias.PermanentPassStaff
])

export const requestTypesWithComments = [
  ...Array.from(permanentTypeAliases),
  RequestTypeAlias.CommonRequest
]
